import { render, staticRenderFns } from "./sysText.vue?vue&type=template&id=485ce870&scoped=true"
import script from "./sysText.vue?vue&type=script&lang=js"
export * from "./sysText.vue?vue&type=script&lang=js"
import style0 from "./sysText.vue?vue&type=style&index=0&id=485ce870&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485ce870",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('485ce870')) {
      api.createRecord('485ce870', component.options)
    } else {
      api.reload('485ce870', component.options)
    }
    module.hot.accept("./sysText.vue?vue&type=template&id=485ce870&scoped=true", function () {
      api.rerender('485ce870', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/basic/sysText/sysText.vue"
export default component.exports